import React, { useEffect } from 'react';
import { hotjar } from 'react-hotjar';
import { QueryClient, QueryClientProvider } from 'react-query';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ThemeProvider } from 'styled-components';
import Routes from './routes';
import reportWebVitals from './utils/reportWebVitals';
import light from './styles/themes/light';
import GlobalStyle from './styles/global';
import GlobalContext, { useApp } from './context';
import ErrorBoundary from './components/ErrorBoundary';

const queryClient = new QueryClient();

const App: React.FC = () => {
  const { online } = useApp();

  useEffect(() => {
    hotjar.initialize({
      id: Number(process.env.REACT_APP_HOTJAR_ID || ''),
      sv: Number(process.env.REACT_APP_HOTJAR_VERSION || ''),
    });

    hotjar.identify('USER_ID', { userProperty: 'value' });
    /*
    // Add an event
    hotjar.event('button-click');

    // Update SPA state
    hotjar.stateChange('/my/page');
    */
  }, []);
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) =>
        console.log(
          'Service Worker registrado com sucesso no escopo: ',
          registration.scope,
        ),
      )
      .catch((err) => {
        console.error('Falha ao registrar Service Worker : ', err);
      });
  } else {
    console.log(
      'Que triste... você não pode aproveitar as vantagens do Service Worker :-(',
    );
  }
  return (
    <>
      <GlobalStyle networkError={!online} />
      <Routes />
    </>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={light}>
          <GlobalContext>
            <App />
          </GlobalContext>
        </ThemeProvider>
      </QueryClientProvider>
    </React.StrictMode>
  </ErrorBoundary>,
);
document.getElementById('root');

reportWebVitals();
